export enum AssetStatus {
  AVAILABLE = 'available',
  STANDBY = 'standby',
  CLOSED = 'closed',
  IMPORTED = 'imported',
}
